export default __webpack_public_path__ + "static/media/assassinaction.0da8160e.png";